var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDesktop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.02344H4.5C3.90326 4.02344 3.33097 4.26049 2.90901 4.68245C2.48705 5.1044 2.25 5.6767 2.25 6.27344V16.7734C2.25 17.3702 2.48705 17.9425 2.90901 18.3644C3.33097 18.7864 3.90326 19.0234 4.5 19.0234H11.25V20.5234H9C8.80109 20.5234 8.61032 20.6025 8.46967 20.7431C8.32902 20.8838 8.25 21.0745 8.25 21.2734C8.25 21.4723 8.32902 21.6631 8.46967 21.8038C8.61032 21.9444 8.80109 22.0234 9 22.0234H15C15.1989 22.0234 15.3897 21.9444 15.5303 21.8038C15.671 21.6631 15.75 21.4723 15.75 21.2734C15.75 21.0745 15.671 20.8838 15.5303 20.7431C15.3897 20.6025 15.1989 20.5234 15 20.5234H12.75V19.0234H19.5C20.0967 19.0234 20.669 18.7864 21.091 18.3644C21.5129 17.9425 21.75 17.3702 21.75 16.7734V6.27344C21.75 5.6767 21.5129 5.1044 21.091 4.68245C20.669 4.26049 20.0967 4.02344 19.5 4.02344ZM4.5 5.52344H19.5C19.6989 5.52344 19.8897 5.60246 20.0303 5.74311C20.171 5.88376 20.25 6.07453 20.25 6.27344V13.7734H3.75V6.27344C3.75 6.07453 3.82902 5.88376 3.96967 5.74311C4.11032 5.60246 4.30109 5.52344 4.5 5.52344ZM19.5 17.5234H4.5C4.30109 17.5234 4.11032 17.4444 3.96967 17.3038C3.82902 17.1631 3.75 16.9724 3.75 16.7734V15.2734H20.25V16.7734C20.25 16.9724 20.171 17.1631 20.0303 17.3038C19.8897 17.4444 19.6989 17.5234 19.5 17.5234Z",
    fill: "#E4E6E7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDesktop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/desktop.a5c4f1f58e575f06b08dcfb0e38b5f7c.svg";